<template>
	<div>
		<div class="account-pages my-5 pt-sm-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 col-lg-6 col-xl-5">
						<div>
							<a href="index.html" class="mb-5 d-block auth-logo">
								<img src="/assets/images/logo-dark.png" alt="" height="22" class="logo logo-dark" />
								<img src="/assets/images/logo-light.png" alt="" height="22" class="logo logo-light" />
							</a>
							<div class="card">
								<div class="card-body p-4">
									<div class="text-center mt-2">
										<h5 class="text-primary">Сброс пароля</h5>
									</div>
									<div class="p-2 mt-4">
										<div class="alert alert-success text-center mb-4" role="alert">
											Введите ваш логин, или email, или номер телефона. На email, указанный в профиле придет письмо для восстановления пароля.
										</div>
										<div class="mb-3">
											<label class="form-label" for="username">Логин, email, номер телефона</label>
											<input type="text" class="form-control" id="username" autofocus />
										</div>
										<div class="mt-3 text-end">
											<button class="btn btn-primary w-sm waves-effect waves-light" type="button">Продолжить</button>
										</div>
										<div class="mt-4 text-center">
											<p class="mb-0">Вспомнили пароль? <router-link :to="{path: '/login'}" class="fw-medium text-primary">Войти</router-link></p>
										</div>
									</div>
								</div>
							</div>
							<div class="mt-5 text-center">
								<p>2022 © Krasp. Разработал <a href="https://bylex.info" target="_blank" class="text-reset">Алексей (lexinzector) Михалёв</a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'RecoveryPassword',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Восстановление пароля | Krasp'});
	},
	data: () => ({
		
	}),
	methods: {
		
	},
	beforeMount(){
		window.scrollTo(0, 0);
		document.body.classList.add('authentication-bg');
	},
	beforeUnmount(){
		document.body.classList.remove('authentication-bg');
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
		document.body.classList.add('authentication-bg');
	},
	computed: {},
	components: {
		
	},
};
</script>